import React from 'react';
import CookieConsent, { Cookies } from 'react-cookie-consent';
import { Link } from 'react-router-dom';

const CookieBanner = () => {
  // The gtag function is globally available from the script in GoogleAnalytics.js

  const handleAccept = () => {
    Cookies.set("tubeTactixGDPRConsent", "true", { domain: ".tubetactix.com", path: "/" });
    window.gtag('consent', 'update', { 'analytics_storage': 'granted' });
    // After consent is granted, send a pageview event to GTM to start tracking.
    // This avoids needing a page reload.
    window.dataLayer.push({
      event: 'page_view',
      page_path: window.location.pathname + window.location.search,
    });
    window.location.reload();
  };

  const handleDecline = () => {
    Cookies.set("tubeTactixGDPRConsent", "false", { domain: ".tubetactix.com", path: "/" });
    window.gtag('consent', 'update', { 'analytics_storage': 'denied' });
    window.location.reload();
  };

  return (
    <CookieConsent
      enableDeclineButton
      flipButtons
      location="bottom"
      buttonText="I understand"
      declineButtonText="I decline"
      cookieName="tubeTactixGDPRConsent"
      onAccept={handleAccept}
      onDecline={handleDecline}
      style={{ background: "#2B373B", zIndex: 1000 }}
      buttonStyle={{
        color: "#4e503b",
        fontSize: "13px",
        background: "#F1D600",
      }}
    >
      We use cookies to enhance your experience and for analytics. Please see our{" "}
      <Link to="/privacy" style={{ color: '#F1D600', textDecoration: 'underline' }}>
        Privacy Policy
      </Link>{" "}
      for details.
    </CookieConsent>
  );
};

export default CookieBanner;